import React, { ChangeEvent } from 'react'
import { FormattedMessage } from 'react-intl'
import type { EditableInfo } from 'src/types'

interface TextAreaProps {
  value: string
  name: keyof EditableInfo
  handleChange: (e: ChangeEvent<HTMLTextAreaElement>, key: keyof EditableInfo) => void
  title: string
}

export default function TextArea ({
  handleChange,
  name,
  title,
  value
}: TextAreaProps) {
  return (
    <label>
      <h2><FormattedMessage id={title} /></h2>
      <textarea
        value={value}
        name={name}
        onChange={(e) => handleChange(e, name)}
      />
    </label>
  )
}
